module.exports = __webpack_public_path__ + "rupesh-fe7cfb405651c4176a80.jpeg";